import { AbstractControl, FormGroup } from '@angular/forms';

export class PasswordValidator {
    static matchPassword(control: AbstractControl) {
        if (control.get('password') && control.get('confirmPassword')) {
            const password = control.get('password')?.value;
            const confirmPassword = control.get('confirmPassword')?.value;
            if (password === confirmPassword) {
              return null;
            } 
        }
        return { passwordsNotMatch: true };
    }
  }
export class FileValidator {
  static validatePdfFile(control: AbstractControl) {
    const file = control.value;
    if (file) {
      const maxSize = 2 * 1024 * 1024; // 2 MB in bytes
      const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];

      if (file.size > maxSize) {
        return { error:'fileSize' };
      }

      if (!allowedTypes.includes(file.type)) {
        return { error:'fileType'};
      }
    }
    return null;
  }
}